import React from "react";
import { Link } from "react-router-dom";
import { colors, fonts } from "@/theme/tokens";

export const Footer: React.FC = () => (
  <footer style={{
    background: colors.dark,
    borderTop: `1px solid rgba(255,255,255,.06)`,
    padding: "36px 24px 32px",
    marginTop: "auto",
  }}>
    <div style={{
      maxWidth: 1200, margin: "0 auto",
      display: "flex", flexDirection: "column", alignItems: "center",
      gap: 20, textAlign: "center",
    }}>

      {/* Logo */}
      <div style={{ display: "flex", alignItems: "center", gap: 9 }}>
        <div style={{
          width: 32, height: 32, borderRadius: 9,
          background: `linear-gradient(135deg, ${colors.primary}, #7C6FE0)`,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 16, flexShrink: 0,
          boxShadow: "0 2px 8px rgba(83,74,183,.35)",
        }}>
          📚
        </div>
        <span style={{ fontFamily: fonts.display, fontWeight: 800, fontSize: 17, letterSpacing: "-0.4px" }}>
          <span style={{ color: "#fff" }}>Adhvi</span>
          <span style={{ color: "#5DCAA5" }}>Books</span>
        </span>
      </div>

      {/* Tagline */}
      <p style={{
        fontSize: 12, color: "#6B6890", lineHeight: 1.6,
        maxWidth: 320, margin: 0,
      }}>
        Free book sharing for kids and families — borrow, share, return &amp; rate.
      </p>

      {/* Links */}
      <nav style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap", justifyContent: "center" }}>
        {[
          { label: "Privacy Policy", to: "/privacy" },
          { label: "Contact",        to: "/contact" },
        ].map((link, i, arr) => (
          <React.Fragment key={link.to}>
            <Link
              to={link.to}
              style={{ fontSize: 12, color: "#9B97C8", fontWeight: 600, textDecoration: "none" }}
              onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
              onMouseLeave={e => (e.currentTarget.style.color = "#9B97C8")}
            >
              {link.label}
            </Link>
            {i < arr.length - 1 && (
              <span style={{ color: "#3C3563", fontSize: 11 }}>·</span>
            )}
          </React.Fragment>
        ))}
      </nav>

      {/* Copyright */}
      <p style={{ fontSize: 11, color: "#3C3563", margin: 0, fontWeight: 600 }}>
        © {new Date().getFullYear()} AdhviBooks. All rights reserved.
      </p>
    </div>
  </footer>
);
